import React from "react";
import { create } from "zustand";

type downloadProgressStoreType = {
  progress?: number;
  setProgress: (number?: number) => void;
};

export const useDownloadProgressStore = create<downloadProgressStoreType>()(
  (set) => ({
    setProgress: (number?: number) => set({ progress: number }),
    progress: undefined,
  })
);

const DownloadProgressBar = (props: { top?: number; bottom?: number }) => {
  const { top, bottom } = props;
  const { progress } = useDownloadProgressStore();
  return (
    <div style={{ zIndex: "250" }}>
      <div
        style={{
          top: top,
          bottom: bottom,
          left: 0,
          width: `${(progress ?? 0) * 100}%`,
          height: "5px",
          zIndex: "250",
          position: "absolute",
          //   transition: "100ms all ease-in-out",
        }}
        className="progress-bar"
      ></div>
    </div>
  );
};

export default DownloadProgressBar;
